'use client';
import { SessionContext } from '@benzinga/session-context';
import {
  LinkFeedEvents,
  WidgetLinkHue,
  WidgetLinkingID,
  WidgetLinkingManager,
  WidgetLinkingManagerEvent,
} from '@benzinga/widget-linking';
import React from 'react';

import Hooks from '@benzinga/hooks';
import { StockSymbol } from '@benzinga/session';

interface TickerLinking {
  currentColor?: WidgetLinkHue;
  currentTicker?: WidgetLinkingID;
}

export const useTickerLinking = (groupId: WidgetLinkingID): TickerLinking | null => {
  const session = React.useContext(SessionContext);

  const update = Hooks.useForceUpdate();

  const linkingManager = React.useMemo(() => {
    return session.getManager(WidgetLinkingManager);
  }, [session]);

  const feed = React.useMemo(() => {
    return linkingManager.getWidgetLinkFeedByID(groupId);
  }, [linkingManager, groupId]);

  const link = feed?.getLink();

  Hooks.useSubscriber(feed, (event: LinkFeedEvents) => {
    switch (event.type) {
      case 'linking:link_event':
        if (event.event.type === 'ticker_selected') {
          update();
        }
    }
  });

  Hooks.useSubscriber(linkingManager, (event: WidgetLinkingManagerEvent) => {
    switch (event.type) {
      case 'linking:link_updated':
        if (event.link.id === groupId) {
          update();
        }
    }
  });
  if (!link) return null;
  const currentColor = link.hue ?? null;
  const currentTicker = link.id ? ((feed?.getLatestEvent('ticker_selected')?.symbol as StockSymbol) ?? null) : null;

  return { currentColor, currentTicker };
};
